var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyright(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.96875C5.796 1.96875 1.96875 5.796 1.96875 10.5C1.96875 15.204 5.796 19.0312 10.5 19.0312C15.204 19.0312 19.0312 15.204 19.0312 10.5C19.0312 5.796 15.204 1.96875 10.5 1.96875ZM10.5 3.28125C14.4939 3.28125 17.7188 6.50606 17.7188 10.5C17.7188 14.4939 14.4939 17.7188 10.5 17.7188C6.50606 17.7188 3.28125 14.4939 3.28125 10.5C3.28125 6.50606 6.50606 3.28125 10.5 3.28125ZM10.4383 6.5625C8.25694 6.5625 6.50081 8.31862 6.50081 10.5C6.50081 12.6814 8.25694 14.4375 10.4383 14.4375C12.0127 14.4375 13.3586 13.4938 13.986 12.161L12.7969 11.6077C12.3736 12.5068 11.4896 13.125 10.4383 13.125C8.94403 13.125 7.81331 11.9943 7.81331 10.5C7.81331 9.00572 8.94403 7.875 10.4383 7.875C11.4896 7.875 12.3743 8.49253 12.7969 9.39291L13.9867 8.83903C13.358 7.50619 12.0127 6.5625 10.4377 6.5625H10.4383Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyright);
export default __webpack_public_path__ + "static/media/copyright.3eee8b4e3259ac452cf9f355aa4a9f6b.svg";
export { ForwardRef as ReactComponent };